import { Component, EventEmitter, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { first } from "rxjs/operators";
import { Consulta } from "src/app/models/consulta";
import { ConsultaComposta } from "src/app/models/consulta-composta";
import { EntradaInfo } from "src/app/models/EntradaInfo";
import { TipoConsulta } from "src/app/models/enum/TipoConsultaEnum";
import { CiacService } from "src/app/services/http/ciac.service";
import { ConsultaService } from "src/app/services/http/consulta.service";
import { RealizarConsultaService } from "src/app/services/http/realizar-consulta.service";
import { LoginService } from "src/app/services/login.service";
import { ModalMsgService } from "src/app/services/modal-msg.service";
import { UserConfigsUtils } from "src/app/utils/UserConfigsUtils";
import { generateIdempotencyKey } from "src/app/utils/idempotency-key.util";

@Component({
  selector: "app-realizar-consulta",
  templateUrl: "./realizar-consulta.component.html",
  styleUrls: ["./realizar-consulta.component.scss"],
})
export class RealizarConsultaComponent implements OnInit {
  listaConsultas: Consulta[] = [];
  listaExperimentais: Consulta[] = [];
  listaCompostas: ConsultaComposta[] = [];
  listaCombinadas: ConsultaComposta[] = [];
  listaCreditos: Consulta[] = [];
  usuario: any = { status: false };
  totalConsultas = 0;
  formView = {
    veiculo: false,
    tipoPesquisaVeiculo: "placa",
    tipoPesquisaCnh: "cnh",
    documento: false,
    cnh: false,
    crlv: false,
    renavam: false,
    placaRenavam: false,
    cpf: 0,
    cnpj: 0,
    uf: 0,
    placa: false,
  };
  params: any;
  consulta: any;

  listaConsultasAdicionais = [];
  consultasCreditoSelecionadas = new EventEmitter();

  consultasSelecionadasCompostas: any = [];
  desmarcarConsultasCompostas: any = [];
  combinadasSelecionadas: any = [];
  desmarcarConsultasCombinadas: any = [];

  ufObrigatorio: boolean = false;
  ufOpcional: boolean = false;

  tipoConsulta = null;
  entradaEscolhida = null;
  listaConsultasSaida = [];
  parametrosEscolhidosArray: Array<string> = [];
  verificandoConsultaEmAndamento = false;
  realizandoConsultaEmAndamento = false;
  idempotencyKeyVerifica: string | null = null;
  idempotencyKeyRealiza: string | null = null;

  constructor(
    private modalService: NgbModal,
    private router: Router,
    private loginService: LoginService,
    private consultaService: ConsultaService,
    private realizarConsultaService: RealizarConsultaService,
    private modalmsg: ModalMsgService,
    private ciacService: CiacService
  ) {}

  ngOnInit() {
    // AVISO HOME PAGE
    // this.modalmsg.open(
    //   `Comunicado Importante – Consulta CRLV-e`,
    //   `Informamos que a consulta CRLV-e está disponível em nosso sistema.
    //   Para que a funcionalidade seja liberada em sua unidade, é necessário acionar o suporte regional responsável. Caso entre em contato com o suporte da matriz, sua solicitação será redirecionada para o atendimento regional correspondente.
    //   Agradecemos a compreensão!
    //   `,
    //   "info",
    //   null,
    //   { text: "Fechar", btnClass: "btn-info" },
    //   { hidden: true },
    //   true
    // );

    this.parametrosEscolhidosArray = [];

    this.loginService
      .getLogIn()
      .pipe(first())
      .subscribe((u) => (this.usuario = u));

    this.consultaService.listaConsulta().then((c) => (this.listaConsultas = c));
    this.ciacService
      .getConsultasCredito()
      .then((c) => (this.listaCreditos = c["lista"]));
    this.consultaService
      .listaConsultaComposta()
      .then((c) => (this.listaCompostas = c))
      .then((c) => this.verificaTipoCredito(c));

    this.consultaService
      .listaConsultaCombinada()
      .then((c) => (this.listaCombinadas = c))
      .then((c) => this.verificaTipoCredito(c));

    this.consultaService
      .listaConsultaExperimental()
      .then((c) => (this.listaExperimentais = c));
  }

  verificaTipoCredito(consultas: ConsultaComposta[]) {
    consultas.forEach((c) => {
      c.possuiConsultaCredito = !!c.consultas.find(
        (filha) => filha.tipoConsulta == "CONSULTA_CREDITO"
      );
    });
  }

  abrirModalForm(modal) {
    this.modalService.open(modal, { centered: true });
  }

  selecionarExperimental(checked, consulta: Consulta) {
    consulta.checked = checked;
    this.listaConsultasSaida = [];
    this.tipoConsulta = null;
    if (checked) {
      this.tipoConsulta = TipoConsulta[TipoConsulta.EXPERIMENTAL];
      this.listaConsultasSaida.push(consulta.id);
    } else {
      this.tipoConsulta = null;
      this.listaConsultasSaida = [];
    }
    this.validaTodos();
    this.updateForm();
  }

  selecionarConsulta(checked, consulta: Consulta) {
    consulta.checked = checked;
    consulta.selfChecked = checked;

    const index = this.listaConsultasSaida.indexOf(consulta.id);

    if (checked) {
      this.tipoConsulta = TipoConsulta[TipoConsulta.AVULSA];
      if (index === -1) {
        this.listaConsultasSaida.push(consulta.id);
      }
    } else {
      if (index !== -1) {
        this.listaConsultasSaida.splice(index, 1);
      }
      if (this.listaConsultasSaida.length === 0) {
        this.tipoConsulta = null;
      }
    }

    this.validaTodos();
    this.updateForm();
  }

  selecionarCredito(checked, consulta: Consulta) {
    consulta.checked = checked;
    consulta.selfChecked = checked;
    this.listaConsultasSaida = [];
    this.tipoConsulta = null;
    if (checked) {
      this.tipoConsulta = TipoConsulta[TipoConsulta.CREDITO];
      this.listaConsultasSaida.push(consulta.id);
    } else {
      this.tipoConsulta = null;
      this.listaConsultasSaida = [];
    }
    this.verificarAdicionais(consulta);
    this.validaTodos();
    this.updateForm();
  }

  selecionarCombinada(checked, consulta: ConsultaComposta) {
    consulta.checked = checked;
    this.listaConsultasSaida = [];
    this.tipoConsulta = null;
    if (checked) {
      this.tipoConsulta = TipoConsulta[TipoConsulta.COMBINADA];
      this.listaConsultasSaida.push(consulta.id);
    } else {
      this.tipoConsulta = null;
      this.listaConsultasSaida = [];
    }
    this.validaTodos();
    this.updateForm();
  }

  selecionarComposta(checked, consulta: ConsultaComposta) {
    consulta.checked = checked;
    this.listaConsultasSaida = [];
    this.tipoConsulta = null;
    if (checked) {
      this.tipoConsulta = TipoConsulta[TipoConsulta.COMPOSTA];
      this.listaConsultasSaida.push(consulta.id);
    } else {
      this.tipoConsulta = null;
      this.listaConsultasSaida = [];
    }
    this.toggleConsultasFilhas(consulta);
    this.validaTodos();
    this.updateForm();
  }

  toggleConsultasFilhas(consulta: ConsultaComposta) {
    consulta.consultas.forEach((c) => {
      const filha = [...this.listaConsultas, ...this.listaCreditos].find(
        (c2) => c2.id == c.id
      );
      if (filha) {
        filha.checked = filha.selfChecked || consulta.checked;
        if (filha["insumos"]) {
          this.verificarAdicionais(filha);
        }
      }
    });
  }

  verificarAdicionais(consulta) {
    if (!consulta.checked) {
      for (let i = 0; i < consulta.insumos.length; i++) {
        consulta.insumos[i].checked = false;
      }
    }
    this.listaConsultasAdicionais = consulta.checked ? consulta.insumos : [];
  }

  selecionarInsumoCredito(checked, consulta: Consulta) {
    consulta.checked = checked;
    const index = this.listaConsultasSaida.indexOf(consulta.id);
    if (checked) {
      this.tipoConsulta = TipoConsulta[TipoConsulta.CREDITO];
      if (index === -1) {
        this.listaConsultasSaida.push(consulta.id);
      }
    } else {
      if (index !== -1) {
        this.listaConsultasSaida.splice(index, 1);
      }
      if (this.listaConsultasSaida.length === 0) {
        this.tipoConsulta = null;
      }
    }
  }

  validaConsultaExperimental() {
    const compostaSelecionada = [
      ...this.listaExperimentais,
      ...this.listaConsultas,
      ...this.listaCompostas,
      ...this.listaCombinadas,
    ].some((c) => c.checked);
    this.listaExperimentais.forEach((c) => {
      c.disabled = false;
      if (compostaSelecionada) {
        c.disabled = true;
      }
      if (c.checked) {
        c.disabled = false;
      }
    });
  }

  validaConsulta() {
    const experimentalSelecionada = this.listaExperimentais.find(
      (c) => c.checked
    );
    const combinadaSelecionada = this.listaCombinadas.find((c) => c.checked);
    const compostaSelecionada = this.listaCompostas.find((c) => c.checked);
    this.listaConsultas.forEach((c) => {
      c.disabled = false;
      if (combinadaSelecionada) {
        c.disabled = true;
      }
      if (experimentalSelecionada) {
        c.disabled = true;
      }
      if (c.checked && !c.selfChecked) {
        c.disabled = true;
      }

      if (compostaSelecionada) {
        const filhaComposta = compostaSelecionada.consultas.some(
          (filha) => filha.id == c.id
        );
        if (filhaComposta) {
          c.disabled = true;
        }
      }
    });
  }

  validaComposta() {
    const compostaSelecionada = [
      ...this.listaExperimentais,
      ...this.listaCompostas,
      ...this.listaCombinadas,
    ].some((c) => c.checked);
    const creditoSelecionada = this.listaCreditos.some((c) => c.checked);
    this.listaCompostas.forEach((c) => {
      c.disabled = false;
      if (compostaSelecionada) {
        c.disabled = true;
      }
      if (creditoSelecionada && c.possuiConsultaCredito) {
        c.disabled = true;
      }
      if (c.checked) {
        c.disabled = false;
      }
    });
  }

  validaCombinada() {
    const compostaSelecionada = [
      ...this.listaExperimentais,
      ...this.listaConsultas,
      ...this.listaCompostas,
      ...this.listaCombinadas,
    ].some((c) => c.checked);
    const creditoSelecionada = this.listaCreditos.some((c) => c.checked);
    this.listaCombinadas.forEach((c) => {
      c.disabled = false;
      if (compostaSelecionada) {
        c.disabled = true;
      }
      if (creditoSelecionada && c.possuiConsultaCredito) {
        c.disabled = true;
      }
      if (c.checked) {
        c.disabled = false;
      }
    });
  }

  validaCredito() {
    const compostaSelecionada = [
      ...this.listaCompostas,
      ...this.listaCombinadas,
    ].some((c) => c.checked);
    const experimentalSelecionada = [...this.listaExperimentais].some(
      (c) => c.checked
    );

    const creditoSelecionada = this.listaCreditos.some((c) => c.checked);
    this.listaCreditos.forEach((c) => {
      c.disabled = false;
      if (compostaSelecionada) {
        c.disabled = true;
      }
      if (experimentalSelecionada) {
        c.disabled = true;
      }
      if (creditoSelecionada) {
        c.disabled = true;
      }
      if (c.checked && c.selfChecked) {
        c.disabled = false;
      }
    });
  }

  validaTodos() {
    this.validaConsultaExperimental();
    this.validaConsulta();
    this.validaCombinada();
    this.validaComposta();
    this.validaCredito();
  }

  updateForm() {
    const combinada = this.listaCombinadas.find((c) => c.checked);
    const listaConsultasCombinada = combinada ? combinada.consultas : [];
    listaConsultasCombinada.forEach((c) => (c.checked = true));
    const lista = [
      ...this.listaExperimentais.filter((c) => c.checked),
      ...this.listaConsultas.filter((c) => c.checked),
      ...this.listaCreditos.filter((c) => c.checked),
      ...listaConsultasCombinada,
    ];
    this.totalConsultas = 0;
    this.formView = {
      veiculo: false,
      tipoPesquisaVeiculo: this.formView.tipoPesquisaVeiculo || "placa",
      tipoPesquisaCnh: this.formView.tipoPesquisaCnh || "cnh",
      documento: false,
      cnh: false,
      crlv: false,
      renavam: false,
      placaRenavam: false,
      cpf: 0,
      cnpj: 0,
      uf: 0,
      placa: false,
    };

    lista.forEach((c) => {
      if (c.checked) {
        this.totalConsultas++;
        const tipo = (c.tipo || c.tipoConsulta || "").toUpperCase();

        switch (tipo) {
          case "CNH":
            this.formView.cnh = true;
            break;

          case "CRLV":
            this.formView.crlv = true;
            break;

          case "BATEU":
          case "DETRAN_PR":
            this.formView.renavam = true;
            break;

          case "DETRANSC":
            this.formView.veiculo = true;
            this.formView.renavam = true;
            break;

          case "CRLV_E":
            this.formView.placa = true;
            this.formView.documento = true;
            this.formView.tipoPesquisaVeiculo = "placa";
            break;

          case "LOCALIZA_VEICULO":
            this.formView.documento = true;
            break;

          case "RELATORIO_SINTETICO_PLUS_SCORE_PF":
          case "RELATORIO_SINTETICO_PLUS_SCORE_SERASA_PF":
          case "RELATORIO_UNIFICADO_PF":
          case "CPF":
            this.formView.cpf++;
            break;

          case "RELATORIO_SINTETICO_PLUS_SCORE_PJ":
          case "RELATORIO_SINTETICO_PLUS_SCORE_SERASA_PJ":
          case "RELATORIO_UNIFICADO_PJ":
          case "CNPJ":
            this.formView.cnpj++;
            break;

          case "UF":
            this.formView.uf++;
            break;

          case "BIN_RENAJUD":
            this.formView.renavam = true;
            this.formView.placa = true;
            this.formView.documento = true;
            break;

          case "CSV":
            this.formView.placa = true;
            this.formView.documento = true;
            this.formView.renavam = true;

          default:
            this.formView.veiculo = true;
            break;
        }

        if (c["ufObrigatorio"]) {
          this.formView.uf++;
        }
      }
    });

    this.ufOpcional = false;
    this.ufObrigatorio = false;

    if (listaConsultasCombinada.length > 0) {
      this.ufOpcional = true;
    } else {
      for (let l of lista) {
        switch (l?.nome?.toUpperCase()) {
          case "DADOS ESTADUAIS":
            this.ufOpcional = true;
            break;
          case "CSV":
            this.ufObrigatorio = true;
            break;
          case "CRLV-E":
            this.ufObrigatorio = true;
            break;
          default:
            break;
        }
      }
    }
  }

  async realizarConsulta(formValues) {
    if (this.verificandoConsultaEmAndamento || this.realizandoConsultaEmAndamento) {
      return;
    }
    if (!formValues) {
      console.error("formulario invalido ou não preenchido");
      return;
    }

    await this.verificarEntrada(formValues);

    const { existeConsulta, minutosRestantes } =
      await this.verificarDuplicidades();

    if (!existeConsulta) {
      await this.realizarConsultaEfetivamente(formValues);
    } else {
      this.modalmsg.open(
        `Atenção!`,
        `Foi realizada uma consulta para esse veículo recentemente. Por favor, aguarde ${minutosRestantes} minuto(s).`,
        "warning",
        null,
        { text: "Fechar", btnClass: "btn-info" },
        { hidden: true },
        true
      );
    }
  }

  private async verificarEntrada(formValues) {
    if (formValues?.chassi && formValues?.chassi != "") {
      this.entradaEscolhida = formValues.chassi;
      this.parametrosEscolhidosArray.push(this.entradaEscolhida);
    }
    if (formValues?.cnh && formValues?.cnh != "") {
      this.entradaEscolhida = formValues.cnh;
      this.parametrosEscolhidosArray.push(this.entradaEscolhida);
    }
    if (formValues?.cnpj && formValues?.cnpj != "") {
      this.entradaEscolhida = formValues.cnpj;
      this.parametrosEscolhidosArray.push(this.entradaEscolhida);
    }
    if (formValues?.cpf && formValues?.cpf != "") {
      this.entradaEscolhida = formValues.cpf;
      this.parametrosEscolhidosArray.push(this.entradaEscolhida);
    }
    if (formValues?.crlv && formValues?.crlv != "") {
      this.entradaEscolhida = formValues.crlv;
      this.parametrosEscolhidosArray.push(this.entradaEscolhida);
    }
    if (formValues?.documento && formValues?.documento != "") {
      this.entradaEscolhida = formValues.documento;
      this.parametrosEscolhidosArray.push(this.entradaEscolhida);
    }
    if (formValues?.motor && formValues?.motor != "") {
      this.entradaEscolhida = formValues.motor;
      this.parametrosEscolhidosArray.push(this.entradaEscolhida);
    }
    if (formValues?.placa && formValues?.placa != "") {
      this.entradaEscolhida = formValues.placa;
      this.parametrosEscolhidosArray.push(this.entradaEscolhida);
    }
    if (formValues?.renavam && formValues?.renavam != "") {
      this.entradaEscolhida = formValues.renavam;
      this.parametrosEscolhidosArray.push(this.entradaEscolhida);
    }
  }

  private async realizarConsultaEfetivamente(formValues: any) {
    let consultasAvulsas = [...this.listaConsultas, ...this.listaExperimentais];
    const params = {
      ip: UserConfigsUtils?.getUserConfigsStorage()?.ip,
      consulta: {
        tipoConsulta: this.tipoConsulta,
        listaConsultasSaida: this.listaConsultasSaida,
      },
      veicular: {
        placa: formValues.placa,
        renavam: formValues.renavam,
        chassi: formValues.chassi,
        motor: formValues.motor,
        crlv: formValues.crlv,
        cnh: formValues.cnh,
        documento: formValues.documento || null,
        uf: formValues?.uf || "",
        consultas: {
          avulsas: consultasAvulsas.filter((c) => c.checked).map((c) => c.id),
          compostas: this.listaCompostas
            .filter((c) => c.checked)
            .map((c) => c.id),
          combinadas: this.listaCombinadas
            .filter((c) => c.checked)
            .map((c) => c.id),
        },
        statusUsuario: this.usuario.status,
        statusPai: (this.usuario["unidade"] || this.usuario["cliente"])[
          "status"
        ],
      },
      credito: {
        nome: formValues.nome || null,
        documento: formValues.cpf || formValues.cnpj || null,
        cmc7: formValues.cmc7 || null,
        uf: formValues.uf || null,
        consultas: {
          avulsas: this.listaCreditos.filter((c) => c.checked).map((c) => c.id),
          compostas: [],
          combinadas: [],
          insumos: this.listaConsultasAdicionais
            .filter((c) => c.checked)
            .map((c) => c.id),
        },
      },
    };

    this.verificandoConsultaEmAndamento = true;
    const idempotencyKey = generateIdempotencyKey("verifica-consulta");
    this.idempotencyKeyVerifica = idempotencyKey;

    try {
      const r = await this.realizarConsultaService.verificaConsulta(params, idempotencyKey);

      if (!r.status) {
        console.log(r.desenvolvedor);
        return this.modalmsg.openDialog(r.titulo, r.texto, "danger", null);
      }
      if (r.erro)
        return this.modalmsg.openDialog(r.titulo, r.texto, "danger", null);

      if (r.encontrado && r.isTempoMinimo)
        return this.openDialogTempoMinimo(r);
      if (r.encontrado) {
        await this.openModal(params, r);
      } else {
        await this.salvarConsulta(params);
      }
    } catch (e) {
      this.modalmsg.openDialog("Erro", e?.error?.msg || "Falha ao verificar consulta.", "danger", null);
    } finally {
      this.verificandoConsultaEmAndamento = false;
      this.idempotencyKeyVerifica = null;
    }
  }

  async openDialogTempoMinimo(r) {
    const modalTitle = " ";
    const modalDesc = `Há uma(s) consulta(s): <b>${r.nomeConsulta}</b>
    <br>
    com a entrada: <b>${this.entradaEscolhida?.toUpperCase()}</b> em andamento.
    <br><br>
    Aguarde ${r.tempoAguardar} minuto(s) para realizar essa consulta novamente. 
    <br><br>
    Deseja abrir a consulta que está em andamento?
    <br><br>`;

    const c = await this.modalmsg.open(
      modalTitle,
      modalDesc,
      "warning",
      null,
      {
        text: "Visualizar consulta em andamento",
        btnClass: "btn-secondary mx-auto",
      },
      { hidden: true },
      true
    );
    if (c === "cancel") {
      let token = r.token;
      this.router.navigate(["consulta", "resultado-cliente", token]);
    }
  }

  async openModal(formValues, r) {
    const modalTitle = `Recentemente foi realizada a(s) consulta(s): ${
      r.nomeConsulta
    } com a entrada: 
      ${this.entradaEscolhida?.toUpperCase()}, deseja visualizá-la ou criar uma nova?`;
    const modalDesc = `Caso seja realizada uma nova consulta, será cobrada e não será feito o estorno do valor!`;

    const c = await this.modalmsg.open(
      modalTitle,
      modalDesc,
      "warning",
      null,
      { text: "Fazer nova consulta", btnClass: "btn-success" },
      { text: "Visualizar consulta anterior", btnClass: "btn-secondary" },
      true,
      "custom-modal"
    );
    if (c === "ok") {
      let token = r.token;
      this.router.navigate(["consulta", "resultado-cliente", token]);
    } else {
      await this.salvarConsulta(formValues);
    }
  }

  async salvarConsulta(params) {
    if (this.realizandoConsultaEmAndamento) {
      return;
    }

    this.realizandoConsultaEmAndamento = true;
    const idempotencyKey = generateIdempotencyKey("fazer-consulta");
    this.idempotencyKeyRealiza = idempotencyKey;

    try {
      const result: any = await this.realizarConsultaService.realizarConsulta(
        { params },
        idempotencyKey
      );
      if (result.msg) {
        this.modalmsg.openDialog(result.msg);
        return;
      }

      this.router.navigate(["consulta", "resultado-cliente", result]);
    } catch (error: any) {
      this.modalmsg.openDialog("Erro", error?.error?.msg || "Falha ao realizar consulta.", "danger", null);
    } finally {
      this.realizandoConsultaEmAndamento = false;
      this.idempotencyKeyRealiza = null;
    }
  }

  async verificarDuplicidades(): Promise<{
    existeConsulta: boolean;
    minutosRestantes: number;
  }> {
    try {
      const entrada = this.parametrosEscolhidosArray
        .sort((a, b) => a.localeCompare(b))
        .map((p) => p.toUpperCase())
        .join(";");

      this.limparLogsExpirados();

      const logs: Record<string, EntradaInfo[]> = JSON.parse(
        localStorage.getItem("logsExpiracao") || "{}"
      );
      const entradaInfo = logs[entrada];

      let registroValido: EntradaInfo | undefined = undefined;
      const timeNow = Date.now();
      const tenMinutesInMs = 10 * 60 * 1000;

      if (entradaInfo) {
        for (const info of entradaInfo) {
          const timePassed = timeNow - info.timestamp;

          if (timePassed <= tenMinutesInMs) {
            if (
              info.lista?.length === this.listaConsultasSaida.length &&
              info.lista.sort((a, b) => a - b).toString() ===
                this.listaConsultasSaida.sort((a, b) => a - b).toString()
            ) {
              registroValido = info;
              break;
            }
          }
        }
      }

      if (!registroValido) {
        this.registrarConsultaStorage(entrada);
        return { existeConsulta: false, minutosRestantes: 0 };
      }

      const timePassed = timeNow - registroValido.timestamp;
      const minutosRestantes = Math.max(
        0,
        Math.ceil((tenMinutesInMs - timePassed) / 60000)
      );

      return { existeConsulta: true, minutosRestantes };
    } catch (error) {
      console.error(error);
      return { existeConsulta: false, minutosRestantes: 0 };
    } finally {
      this.parametrosEscolhidosArray = [];
    }
  }

  registrarConsultaStorage(entrada: string) {
    const timeNow = Date.now();
    const dataAtual = new Date().toISOString().split("T")[0];

    const entradaInfo: EntradaInfo = {
      timestamp: timeNow,
      dataConsulta: dataAtual,
      lista: this.listaConsultasSaida.sort((a, b) => a - b),
    };

    this.atualizarLogExpiracao(entrada, entradaInfo);
  }

  atualizarLogExpiracao(entrada: string, entradaInfo: EntradaInfo) {
    const logs: Record<string, EntradaInfo[]> = JSON.parse(
      localStorage.getItem("logsExpiracao") || "{}"
    );
    if (!logs[entrada]) {
      logs[entrada] = [];
    }
    logs[entrada].push(entradaInfo);
    localStorage.setItem("logsExpiracao", JSON.stringify(logs));
  }

  limparLogsExpirados() {
    const logs: Record<string, EntradaInfo[]> = JSON.parse(
      localStorage.getItem("logsExpiracao") || "{}"
    );
    const dataAtual = new Date().toISOString().split("T")[0];

    for (const [entrada, entradaInfo] of Object.entries(logs)) {
      const registrosValidos = (entradaInfo as EntradaInfo[]).filter(
        (info) => info.dataConsulta === dataAtual
      );
      if (registrosValidos.length === 0) {
        delete logs[entrada];
      } else {
        logs[entrada] = registrosValidos;
      }
    }

    localStorage.setItem("logsExpiracao", JSON.stringify(logs));
  }
}
